import { useEffect, useState } from 'react';
import { Table, Button, Space } from 'antd';
import { useNavigate } from 'react-router-dom';
import DashboardService from '../../utils/api/DashboardService';
import moment from 'moment';

export default function OrdersList({ dateRange, monthRange, year }) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const fetchOrders = async () => {
    try {
      setLoading(true);
      
      let params = {};

      if (dateRange && dateRange.length === 2) {
        params.start_date = dateRange[0].format('YYYY-MM-DD');
        params.end_date = dateRange[1].format('YYYY-MM-DD');
      } 
      else if (monthRange && monthRange.length === 2) {
        params.start_date = monthRange[0].clone().startOf('month').format('YYYY-MM-DD');
        params.end_date = monthRange[1].clone().endOf('month').format('YYYY-MM-DD');
      }
      else if (year && year !== new Date().getFullYear()) {
        params.year = year;
      }
      else {
        const today = moment();
        const firstDayOfMonth = today.clone().startOf('month');
        params.start_date = firstDayOfMonth.format('YYYY-MM-DD');
        params.end_date = today.format('YYYY-MM-DD');
      }

      const response = await DashboardService.getOrdersAll(params);
      console.log('Orders response:', response);
      if (response.data.success) {
        
        const formatted = response.data.orders
          .map((order, index) => ({
            id: index, 
            order_number: order.order_id,
            client_name: order.client,
            title: order.title
          }))
          .sort((a, b) => {
            // Extraer números de las órdenes para ordenarlas correctamente
            const numA = parseInt(a.order_number.replace(/\D/g, '')) || 0;
            const numB = parseInt(b.order_number.replace(/\D/g, '')) || 0;
            return numA - numB;
          })
          .map((order, index) => ({
            ...order,
            numero: index + 1
          }));

        console.log('Formatted orders:', formatted);

        setData(formatted);
      }

    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchOrders();
  }, [dateRange, monthRange, year]);

  const columns = [
    {
      title: '#',
      dataIndex: 'numero',
      key: 'numero',
      width: 60,
      align: 'center',
    },
    {
      title: 'Nro de Orden',
      dataIndex: 'order_number',
      key: 'order_number',
    },
    {
      title: 'Cliente',
      dataIndex: 'client_name',
      key: 'client_name',
    },
    {
      title: 'Título',
      dataIndex: 'title',
      key: 'title',
    },
    {
      title: 'Acciones',
      key: 'actions',
      render: (_, record) => (
        <Space>
          
          <Button
            type="primary"
            onClick={() => navigate(`/orders/details/new/${record.order_number}`)}
          >
            Ir a orden
            
          </Button>
        </Space>
      ),
    },
  ];

  return (
    <div>     

      <Table
        className="orders-table"
        columns={columns}
        dataSource={data}
        rowKey="order_number"
        loading={loading}
        pagination={{ pageSize: 10 , align: 'center' , showSizeChanger: true, pageSizeOptions: ['10', '20', '50']}}
        style={{ width: '100%' }}
      />
    </div>
  );
}